import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../layout/dashboard";

const useQuery = () => new URLSearchParams(useLocation().search);
const Index = () => {
  const query = useQuery();
  const utmSource = query.get("utm_source");
  const utmMedium = query.get("utm_medium");
  const utmCampaign = query.get("utm_campaign");

  const navigate = useNavigate();
  const [cookies] = useCookies();

  useEffect(() => {
    if (cookies["token"]) {
      navigate("/v2/home");
    } else {
      const params = new URLSearchParams();

      if (utmSource) params.append("utm_source", utmSource);
      if (utmMedium) params.append("utm_medium", utmMedium);
      if (utmCampaign) params.append("utm_campaign", utmCampaign);

      const queryString = params.toString();
      navigate(`/auth/login${queryString ? `?${queryString}` : ""}`);
    }
  }, []);

  return <Dashboard />;
};

export default Index;
